import React, { FC, useEffect, useState } from 'react';
import { EditApplicationsContainer } from './viewApplicationEditScreen.styles';
import { RadioButtonField } from '@sainsburys-tech/luna-react';
import { IApplicationDetails } from 'src/interfaces/application.interface';
import { Button } from '@sainsburys-tech/luna-react';
import { ScreenFeedback } from 'src/screens/components/screenFeedback';
import { ApolloError } from '@apollo/client';
import { NotificationType } from 'src/enums/notificationTypes.enum';
import { PanelActions } from 'src/components/PanelActions/panelActions.styles';

interface IHeading {
  heading: string;
  subHeading: string;
  feedBackStatus: string;
}

interface IEditApplicationTypeRadioScreen {
  handleClose: () => void;
  handleConfirmation: (status: string) => void;
  loading: boolean;
  error: ApolloError | undefined;
  target: { id: string; displayName: string };
  radioHeading: IHeading;
  defaultValue: string;
}

export const EditApplicationTypeRadioScreen: FC<IEditApplicationTypeRadioScreen> = ({
  handleConfirmation,
  handleClose,
  error,
  radioHeading,
  target,
  defaultValue,
}) => {
  const [selectedValue, setSelectedValue] = useState<string | null>(null);
  const [feedBackMessage, setFeedBackMessage] =
    useState<NotificationType | null>(null);
  useEffect(() => {
    if (error) {
      setFeedBackMessage(NotificationType.FAILURE);
    }
  }, [error]);

  const handleReset = () => {
    setSelectedValue(null);
    setFeedBackMessage(null);
  };

  return (
    <>
      <EditApplicationsContainer>
        {feedBackMessage ? (
          <>
            <ScreenFeedback
              isLoading={false}
              notificationType={feedBackMessage}
              feedBackMessage={
                feedBackMessage === NotificationType.SUCCESS
                  ? `The ${radioHeading.feedBackStatus} status has been updated for this app`
                  : `Failed to update the ${radioHeading.feedBackStatus} for this app.`
              }
              saveButtonText={'Save and close'}
              onCloseHandler={handleClose}
              resetButtonText={'Further changes'}
              resetHandler={handleReset}
              notificationMessage={
                feedBackMessage === NotificationType.SUCCESS
                  ? `Application successfully updated`
                  : 'Failed to update application'
              }
            />
          </>
        ) : (
          <>
            <div className='tab-heading'>
              <h3>{radioHeading.heading}</h3>
            </div>
            <div className='panel-body'>
              <RadioButtonField
                label={radioHeading.subHeading}
                name={`${radioHeading.feedBackStatus}-radio-button`}
                fullWidth
                options={[
                  {
                    value: 'UI',
                    label: 'UI',
                    defaultChecked: defaultValue === 'UI' ? true : false,
                  },
                  {
                    value: 'SERVICE',
                    label: 'Service',
                    defaultChecked: defaultValue === 'SERVICE' ? true : false,
                  },
                  {
                    value: 'EXT',
                    label: 'External',
                    defaultChecked: defaultValue === 'EXT' ? true : false,
                  },
                ]}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setSelectedValue(e.target.value === 'UI' ? 'UI' : e.target.value === 'SERVICE' ? 'SERVICE' : 'EXT');
                }}
              />
            </div>
          </>
        )}
      </EditApplicationsContainer>
      {!feedBackMessage && (
        <PanelActions>
          <Button
            onClick={() => {
              if (selectedValue !== null) {
                handleConfirmation(selectedValue);
                setFeedBackMessage(NotificationType.SUCCESS);
              }
            }}
            variant='filled'
            disabled={selectedValue === null}
          >
            Set status
          </Button>
          <Button onClick={handleClose} variant='outlined'>
            Cancel
          </Button>
        </PanelActions>
      )}
    </>
  );
};
